export default __webpack_public_path__ + "static/media/history_2.eeaeff35.png";